import { render, staticRenderFns } from "./contract-collapse.vue?vue&type=template&id=73b6d012&scoped=true"
import script from "./contract-collapse.vue?vue&type=script&lang=js"
export * from "./contract-collapse.vue?vue&type=script&lang=js"
import style0 from "./contract-collapse.vue?vue&type=style&index=0&id=73b6d012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6d012",
  null
  
)

export default component.exports